import { translate } from '@manomano-internal/i18n/esm/placeholders';
import { isB2C } from '@/core/settings/utils';
import { Carousel } from '@/domains/core/tamagoshi/Carousel/Carousel';
import { HighlightedCouponContainer } from '@/domains/loyalty/modules/HighlightedCoupon/HighlightedCouponContainer';
import { ProPriceAndWelcomeOffer } from '@/domains/productDiscovery/ProductPage/common/components/Advantages/ProPriceAndWelcomeOffer/ProPriceAndWelcomeOffer';
import { AdvantagesCard } from '@/productDiscovery/ProductPage/common/components/Advantages/AdvantagesCard/AdvantagesCard';
import { SuperProWithFallbacks } from '@/productDiscovery/ProductPage/common/components/Advantages/SuperProWithFallbacks/SuperProWithFallbacks';
const {
  manomanoAdvantages
} = translate({
  "manomanoAdvantages": "ManoMano Benefits"
});
export const Advantages = () => {
  return <>
      <Carousel title={manomanoAdvantages} titleClassName="!font-semibold" className="gap-m pt-l" sliderClassName="gap-s" controlsClassName="px-m" horizontalPadding="md">
        {isB2C() ? <AdvantagesCard>
            <ProPriceAndWelcomeOffer />
          </AdvantagesCard> : <AdvantagesCard>
            <SuperProWithFallbacks />
          </AdvantagesCard>}

        <HighlightedCouponContainer />
      </Carousel>
    </>;
};
Advantages.displayName = 'Advantages';